/* ============================================================
   Модалка «Стать спонсором»: форма (тип/имя/телефон/сообщение)
   и экран успеха. Заявка уходит в бэкенд (support-тикет) и в
   локальный контент-стор — сразу видна в админке.
   ============================================================ */
import { useState } from 'react';
import { useFedStore, useL } from '../store';
import { Ic } from '../icons';
import { Field } from '../ui';

export default function FedSponsorModal() {
  const { sponsorOpen, sponsorSent, sponsorType, setSponsorType, closeSponsor, submitSponsor } = useFedStore();
  const L = useL();
  const [form, setForm] = useState({ name: '', phone: '', message: '' });

  if (!sponsorOpen) return null;

  const types = [
    { key: 'gen', label: L.sp_t_gen },
    { key: 'tour', label: L.sp_t_tour },
    { key: 'media', label: L.sp_t_media },
  ];

  const onSubmit = (e) => {
    e.preventDefault();
    submitSponsor(form);
  };

  return (
    <div
      onClick={closeSponsor}
      className="fixed inset-0 flex items-center justify-center p-5"
      style={{ zIndex: 300, background: 'rgba(4,4,6,.74)', backdropFilter: 'blur(7px)', WebkitBackdropFilter: 'blur(7px)', animation: 'fedPageIn .28s var(--fed-ease) both' }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-[470px] overflow-y-auto rounded-[20px] border border-line-2 shadow-card-lg"
        style={{ maxHeight: '92vh', background: 'linear-gradient(165deg,var(--fed-surface-2),var(--fed-surface))', animation: 'fedRvIn .35s var(--fed-spring) both' }}
      >
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 82% -12%,rgba(225,18,23,.24),transparent 55%)' }} />
        <button
          onClick={closeSponsor}
          className="absolute z-[3] w-[34px] h-[34px] rounded-[9px] border border-line bg-surface-2 text-fg-muted cursor-pointer"
          style={{ top: 14, right: 14 }}
        >
          <Ic name="x" size={15} sw={2.2} />
        </button>

        {!sponsorSent ? (
          <div className="relative p-[30px]">
            <div
              className="w-[52px] h-[52px] rounded-[14px] flex items-center justify-center mb-4 text-accent-bright"
              style={{ background: 'rgba(225,18,23,.1)', border: '1px solid var(--fed-line-accent)' }}
            >
              <Ic name="zap" size={24} sw={1.8} />
            </div>
            <h2 className="font-body font-extrabold text-fg" style={{ fontSize: 26, textTransform: 'none', letterSpacing: 0 }}>{L.sp_title}</h2>
            <p className="text-fg-muted mt-2.5" style={{ fontSize: 14, lineHeight: 1.6 }}>{L.sp_sub}</p>

            <form onSubmit={onSubmit} className="flex flex-col gap-[15px] mt-[22px]">
              <div>
                <div className="fed-label mb-[9px]">{L.sp_type}</div>
                <div className="flex gap-1.5 p-[5px] bg-surface-2 border border-line rounded-xl">
                  {types.map((t) => (
                    <button
                      key={t.key}
                      type="button"
                      onClick={() => setSponsorType(t.key)}
                      className="flex-1 h-10 border-none rounded-lg cursor-pointer font-display font-semibold uppercase transition-colors"
                      style={{
                        fontSize: 13.5, letterSpacing: '.03em',
                        background: sponsorType === t.key ? 'linear-gradient(120deg,var(--fed-accent-bright),var(--fed-accent-deep))' : 'transparent',
                        color: sponsorType === t.key ? '#fff' : 'var(--fed-fg-muted)',
                      }}
                    >
                      {t.label}
                    </button>
                  ))}
                </div>
              </div>
              <Field label={L.sp_name}>
                <input className="fed-input" type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
              </Field>
              <Field label={L.sp_phone}>
                <input className="fed-input" type="tel" placeholder="+7 ___ ___ __ __" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} required />
              </Field>
              <Field label={L.sp_msg}>
                <textarea className="fed-input" rows={3} placeholder={L.sp_msg_ph} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
              </Field>
              <button type="submit" className="fed-btn-primary h-[52px]" style={{ fontSize: 16 }}>{L.sp_send}</button>
              <p className="text-fg-faint text-center" style={{ fontSize: 11.5, lineHeight: 1.5 }}>{L.sp_note}</p>
            </form>
          </div>
        ) : (
          <div className="relative text-center flex flex-col items-center gap-3.5" style={{ padding: '44px 30px' }}>
            <div
              className="w-[74px] h-[74px] rounded-full flex items-center justify-center"
              style={{ background: 'rgba(67,217,106,.14)', border: '1px solid rgba(67,217,106,.45)', color: 'var(--fed-ok)', boxShadow: '0 0 34px -10px rgba(67,217,106,.5)' }}
            >
              <Ic name="check" size={34} sw={2.4} />
            </div>
            <h2 className="font-body font-extrabold text-fg" style={{ fontSize: 26, textTransform: 'none', letterSpacing: 0 }}>{L.sp_ok_t}</h2>
            <p className="text-fg-muted max-w-[320px]" style={{ fontSize: 15, lineHeight: 1.6 }}>{L.sp_ok_d}</p>
            <button onClick={closeSponsor} className="fed-btn-ghost h-12 px-[26px] mt-2 rounded-[11px]" style={{ fontSize: 15 }}>{L.sp_close}</button>
          </div>
        )}
      </div>
    </div>
  );
}
